/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 連携活動その他2
 */
export type BaseInfoCollaborationOther2Enum =
  (typeof BaseInfoCollaborationOther2Enum)[keyof typeof BaseInfoCollaborationOther2Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseInfoCollaborationOther2Enum = {
  DR_HELI: 'DR_HELI',
  DISASTER_DR_HELI: 'DISASTER_DR_HELI',
  DR_CAR: 'DR_CAR',
} as const;
